module.exports = __webpack_public_path__ + "img/link_hover_en.e4ea869f.png";